import { useField } from "formik";
import { DateValue } from "react-aria-components";

import {
  DatePicker,
  DatePickerProps,
} from "../components/inputs/date-input/DatePicker";
import { parseDateFromValue } from "../components/inputs/date-input/utils";

interface Props extends DatePickerProps {
  name: string;
  testID: string;
}

export function DatePickerFormikField(props: Props) {
  const { name, testID, label, info, ...rest } = props;

  const [field, meta, helpers] = useField(name);

  return (
    <DatePicker
      {...rest}
      label={label}
      testID={testID}
      name={name}
      info={info}
      isInvalid={Boolean(meta.touched && meta.error)}
      errors={meta.touched ? meta.error : undefined}
      onBlur={() => helpers.setTouched(true)}
      value={parseDateFromValue(field.value)}
      onChange={(value: DateValue | null) => {
        helpers.setValue(value ? value.toString() : null);
      }}
    />
  );
}
